"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _reactToastify = require("react-toastify");

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var ToastHelper = /*#__PURE__*/function () {
  function ToastHelper() {
    _classCallCheck(this, ToastHelper);
  }

  _createClass(ToastHelper, null, [{
    key: "setAlert",
    value: function setAlert(alertElement) {
      this.alertElement = alertElement;
    }
  }, {
    key: "show",
    value: function show(text) {
      var options = {
        type: _reactToastify.toast.TYPE.ERROR,
        hideProgressBar: false,
        position: _reactToastify.toast.POSITION.TOP_RIGHT,
        pauseOnHover: true,
        autoClose: 3000,
        closeOnClick: true,
        draggable: true
      };

      if (!_reactToastify.toast.isActive(this.toastId)) {
        this.toastId = (0, _reactToastify.toast)(text, options);
      }
    }
  }, {
    key: "close",
    value: function close() {
      _reactToastify.toast.dismiss();
    }
  }]);

  return ToastHelper;
}();

exports["default"] = ToastHelper;

_defineProperty(ToastHelper, "alertElement", null);

_defineProperty(ToastHelper, "toastId", null);